import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.policies', {
        url: '/policies',
        component: 'requestCenterPolicies',
        redirectTo: 'company.request-center.policies.list',
        resolve: {policies, defaultPolicy},
    })
}

/** @ngInject */
function policies(ApprovalPoliciesService, $stateParams) {
    return ApprovalPoliciesService.getPoliciesForCompany($stateParams.companyId);
}

/** @ngInject */
function defaultPolicy(policies) {
    return policies.find(policy => policy.policyName === 'Default Policy');
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/approval-policies.state.js